import { default as isManyDayView } from './isManyDayView';
import { CalendarLayoutBrowserConstants } from '../constants';
import { DateRangeType } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';
import { isBoardViewTypeSelected } from 'owa-calendar-module-store';
import { getSurfaceStore } from 'owa-calendar-surface-surface-store';
import { getBrowserWidthBucket } from 'owa-layout';

export function shouldShowLeftNavAsOverlay() {
    const { dateRangeType } = getSurfaceStore();
    const availableWidthBucket = getBrowserWidthBucket();

    if (isBoardViewTypeSelected()) {
        return (
            availableWidthBucket <= CalendarLayoutBrowserConstants.shouldShowLeftNavAsOverlay_BOARD
        );
    } else {
        if (dateRangeType == DateRangeType.Month) {
            return (
                availableWidthBucket <=
                CalendarLayoutBrowserConstants.shouldShowLeftNavAsOverlay_MONTH
            );
        } else if (isManyDayView()) {
            return (
                availableWidthBucket <=
                CalendarLayoutBrowserConstants.shouldShowLeftNavAsOverlay_WEEK
            );
        }
        return (
            availableWidthBucket <= CalendarLayoutBrowserConstants.shouldShowLeftNavAsOverlay_DAY
        );
    }
}
